import conf from '../config/api.js';
import Vue from 'vue';
import script from './script.js'
import vuexStorage from '../store/index.js'
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction d'ajout d'un contact
function addContact (formData) {
  this.axios.post(conf.server+'/api/addContact', formData, { withCredentials: true })
    .then(() => {
      this.$bvToast.toast(`Le contact a été ajouté`, {
        title: 'Ajout d\'un contact',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Ajout de contact impossible`,'Ajout de contact')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('../login')
      }
    })
}

//Fonction d'ajout en masse de compte
function addMassiveContact(){
  for(var i=0;i<this.selectedContact.length;i++){
    iterateMassiveContact.call(this,this.selectedContact[i],this.templateSelected);
  }
}

//Fonction de connexion sur un compte client un compte admin
async function connectOnClient(clientId,socId){
  var connected = confirm("Voulez-vous vous connecter au compte de ce client?");
  if(connected){
    try {
      var response = await requestApi({method:"POST", url:"/api/connectAdminClient", params:{}, form:{clientId: clientId, socid: socId}, headers:{'Content-Type': 'application/json'}});
      this.$router.push(response.route);
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Connexion au compte client impossible`,'Connexion compte client')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('login');
      }  
    }
  }
}

//Fonction de création d'accès client
function createAccess(email,contenuMail,pwd,tokenReinit,socid){
  this.axios.post(conf.server+"/api/createAccess",{email: email, contenuMail: contenuMail, pwd: pwd, socid: socid, tokenReinit:tokenReinit},{withCredentials:true})
  .then((response) => {
    alert("Accès créée avec succès!");
    this.loadingClient();
    this.expandClientInfo(socid);
  })
  .catch((error) => {
    if(error.response != undefined){
      toasterError(`Création d'accès impossible`,'Création d\'accès')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      this.$router.push('/');
    }
  })
}

//Fonction de suppression d'un contact
function delContact (id) {
  this.axios.post(conf.server+'/api/delContact',{id:id}, { withCredentials: true })
    .then(() => {
      this.$bvToast.toast(`Le contact a été supprimé`, {
        title: 'Suppression d\'un contact',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
    })
    .catch((error) => {
    if(error.response != undefined){
      toasterError(`Suppression de contact impossible`,'Suppression de contact')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
    })
}

//Fonction de suppression d'accès client
function deleteAccess(contactid,socid){
  var deleteExtranet = confirm("Etes-vous sûr de vouloir supprimer l'accès à l'extranet de ce client?");
  if(deleteExtranet == true){
    this.axios.post(conf.server+"/api/deleteAccess",{id: contactid},{withCredentials:true})
    .then(() => {
      this.expandClientInfo(socid);
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Suppression d'accès impossible`,'Suppression d\'accès')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('/');
      }
    })
  }
}

//Fonction de suppression de propale
function deletePropale(id){
  var deleteDevis = confirm("Etes-vous sûr de vouloir supprimer ce devis?");
  if(deleteDevis == true){
    this.axios.post(conf.server+"/api/deletePropale",{id: id}, {withCredentials: true})
      .then(() => {
        toasterSuccess(`Suppression de devis réussie`,'Suppression de devis')
        vuexStorage.commit("delProposal",id)
      })
      .catch(() => {
        toasterError(`Suppression de devis échouée`,'Suppression de devis')
      })
  }
}

//Fonction de suppression de tiers
function deleteTiers(id){
  var deleteClient = confirm("Voulez-vous supprimer le tiers?");
  if(deleteClient == true){
    this.axios.post(conf.server+"/api/deleteTiers",{id:id},{withCredentials:true})
    .then((response) => {
      if(response.data!=0){
        this.$bvToast.toast(`Le tiers à été supprimé avec succès`, {
          title: 'Suppression de tiers',
          toaster: 'b-toaster-bottom-right',
          variant: 'success',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        this.loadingClient();
      }else{
        this.$bvToast.toast(`Le tiers ne peut pas être supprimé car il y a un document en cours d'édition`, {
          title: 'Suppression de tiers',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        this.loadingClient();
      }
    })
    .catch(()=>{
      this.$bvToast.toast(`Suppression impossible`, {
        title: 'Suppression de tiers',
        toaster: 'b-toaster-bottom-right',
        variant: 'danger',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
    })
  }
}

//Fonction de chargement des infos des clients
function detailsTiers (id,that) {
  if (!that) {
    that = this
  }
  that.axios.get(conf.server+"/api/detailsTiers",{params:{id: id}},{withCredentials:true})
  .then((response) => {
    vuexStorage.commit('updateInfoSoc', response.data)
  })
  .catch((error) => {
    if(error.response != undefined){
      toasterError(`Impossible de charger les détails du tiers`,'Détails du tiers')
      if(error.response.status!=404){
        that.$router.push('../login');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      that.$router.push('../tiers');
    }
  })
}

//Fonction de chargement des infos d'accès du client
function expandClientInfo(id){
  this.axios.get(conf.server+"/api/verifyAccess/" + id,{withCredentials:true})
  .then((response) => {
    this.clientsExtranet = response.data;
    this.axios.get(conf.server+"/api/loadingContacts",{params:{id: id}},{withCredentials:true})
    .then((response) => {
      this.infosContacts = response.data;
      for(var j=0; j<this.infosContacts.length; j++){
        this.infosContacts[j]["acces"]=false;
      }
      for(var i=0; i<this.clientsExtranet.length; i++){
        for(j=0; j<this.infosContacts.length; j++){
          if((this.infosContacts[j]["id"]==this.clientsExtranet[i]["contactid"])||(this.infosContacts[j]["id"]==this.clientsExtranet[i]["contact_id"])){
            this.infosContacts[j]["acces"]=true;
            var dateC = new Date(this.clientsExtranet[i]["datec"]*1000);
            var jour = dateC.getDate();
            if(jour < 10){
              jour = '0' + jour;
            }
            var mois = dateC.getMonth()+1;
            if (mois < 10) { 
              mois = '0' + mois; 
            }
            var annee = dateC.getFullYear();
            this.infosContacts[j]["datec"]=annee+"-"+mois+"-"+jour;
          }
        }
      }
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Chargement des contacts impossible`,'Chargement des contacts')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  })
  .catch((error) => {
    this.axios.get(conf.server+"/api/loadingContacts",{params:{id: id}},{withCredentials:true})
    .then((response) => {
      this.infosContacts = response.data;
    })
    .catch((error2) => {
      if(error2.response != undefined){
        toasterError(`Chargement des contacts impossible`,'Chargement des contacts')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
    if(error.response != undefined){
      toasterError(`Impossible d'effectuer la vérification`,'Verification')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de chargement des clients
function loadingClient(){
  if(this.$route.params.id){
    this.axios.get(conf.server+"/api/verifyAccess/" + this.$route.params.id,{withCredentials:true})
    .then((response) => {
      this.clientsExtranet = response.data;
      this.axios.post(conf.server+"/api/loadingClient",{},{withCredentials:true})
      .then((response) => {
        this.tiers = response.data;
        this.numberOfPages = this.tiers.length / this.perPage;
        for(var j=0; j<this.clients.length; j++){
            this.tiers[j]["acces"]=false;
            this.tiers[j]["_showDetails"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      })
      .catch((error)=>{
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      })
    })
    .catch((error) => {
      this.axios.post(conf.server+"/api/loadingClient",{},{withCredentials:true})
      .then((response) => {
        this.tiers = response.data;
        this.numberOfPages = this.tiers.length / this.perPage;
        for(var j=0; j<this.tiers.length; j++){
            this.tiers[j]["acces"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      })
      .catch((error)=>{
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      })
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  }else{
    this.axios.get(conf.server+"/api/verifyAccess",{withCredentials:true})
    .then((response) => {
      this.clientsExtranet = response.data;
      this.axios.post(conf.server+"/api/loadingClient",{},{withCredentials:true})
      .then((response) => {
        this.tiers = response.data;
        this.numberOfPages = this.tiers.length / this.perPage;
        for(var j=0; j<this.clients.length; j++){
            this.tiers[j]["acces"]=false;
            this.tiers[j]["_showDetails"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      })
      .catch((error)=>{
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          //toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      })
    })
    .catch((error) => {
      this.axios.post(conf.server+"/api/loadingClient",{},{withCredentials:true})
      .then((response) => {
        this.tiers = response.data;
        this.numberOfPages = this.tiers.length / this.perPage;
        for(var j=0; j<this.tiers.length; j++){
            this.tiers[j]["acces"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      })
      .catch((error)=>{
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      })
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  }
}

//Fonction de chargement des dictionnaires
function loadingDictionary(){
  this.optionsPayment.push({value: "0",text: ""})
  this.optionsDeliveryDelay.push({value: "0",text: ""})
  this.axios.get(conf.server+"/api/getDictionary",{withCredentials:true})
    .then((response) => {
      var conditionPayment = response.data.conditionPayment
      var typePayment = response.data.typePayment
      var deliveryDelay = response.data.deliveryDelay
      var i
      for(i=0;i<conditionPayment.length;i++){
        this.optionsConditionsPayment.push({value: conditionPayment[i].id, text: conditionPayment[i].label})
      }
      for(i=0;i<typePayment.length;i++){
        this.optionsPayment.push({value:typePayment[i].code, text: typePayment[i].label})
      }
      for(i=0;i<deliveryDelay.length;i++){
        this.optionsDeliveryDelay.push({value: deliveryDelay[i].code, text: deliveryDelay[i].label})
      }
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Impossible de charger les dictionnaires`,'Chargement des dictionnaires')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
}

//Fonction pour la selection pour l'ajout de masse à l'extranet
function openAjoutExtranet(target){
  this.axios.get(conf.server+"/api/verifyAccess",{withCredentials:true})
  .then((response) => {
    this.clientsExtranet = response.data;
    this.axios.get(conf.server+"/api/loadingAllContacts",{withCredentials:true})
    .then((response) => {
      var res = response.data;
      for(var j=0; j<res.length; j++){
        res[j]["acces"]=false;
      }
      for(var i=0; i<this.clientsExtranet.length; i++){
        for(j=0; j<res.length; j++){
          if(res[j]["id"]==this.clientsExtranet[i]["contact_id"]){
            res[j]["acces"]=true;
          }
        }
      }
      for(j=0; j<res.length; j++){
        if(res[j]["acces"]==false){
          this.contacts.push(res[j]);
        }
      }
      this.$root.$emit('bv::show::modal', 'modalAjoutExtranet',target);
    })
    .catch(()=>{
    })
  })
  .catch((error) => {
    this.axios.post(conf.server+"/api/loadingAllContacts",{},{withCredentials:true})
    .then((response) => {
      this.contacts = response.data;
      for(var j=0; j<this.contacts.length; j++){
          this.contacts[j]["acces"]=false;
      }
      this.$root.$emit('bv::show::modal', 'modalAjoutExtranet',target);
    })
    .catch((error)=>{
    if(error.response != undefined){
      toasterError(`Chargement des contacts impossible`,'Chargement des contacts')

    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
    })
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de mise à jours des champs
function updateFields (type, id, field, value) {
  this.axios.post(conf.server+'/api/updateFields',{type:type,id:id,field:field,value:value}, { withCredentials: true })
    .then(() => {
      this.$bvToast.toast(`Les modifications ont été enregistrées`, {
        title: 'Modification rapide',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
    })
    .catch(() => {
      this.$router.push('../login')
    })
}

//Fonction de validation de propale
function validateObject(type, id){
  this.axios.post(conf.server+'/api/validateObject',{type: type, id: id},{withCredentials:true})
  .then(() => {
    this.proposals = []
    script.loadDocuments("proposals");
  })
  .catch(() => {
    toasterError(`Une erreur interne est survenue`,'Erreur interne')
  })
}

//Fonction de visualisation des devis client admin
function visualDevisTiers(item,target){
  let src = conf.server+"/api/visualDoc/"+item.last_main_doc;
  let title ="Document "+item.ref+" : "+item.ref_client+" du "+moment(item.datec*1000).format("L");
  vuexStorage.commit("setModalDoc",{src:src, title:title})
  this.$root.$emit('bv::show::modal', 'modalVisualDevisTiers',target);
}

//Fonction de visualisation des factures client admin
function visualFacTiers(item,target){
  this.visualSrcFacTiers = conf.server+"/api/visualDoc/"+item.last_main_doc;
  this.modalVisualFacTiers.title="Document "+item.ref+" : "+item.ref_client+" du "+item.date_creation;
  this.$root.$emit('bv::show::modal', 'modalVisualFacTiers',target);
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
  loadingClient,
  expandClientInfo,
  createAccess,
  deleteAccess,
  connectOnClient,
  detailsTiers,
  updateFields,
  addContact,
  delContact,
  visualDevisTiers,
  visualFacTiers,
  deleteTiers,
  openAjoutExtranet,
  addMassiveContact,
  loadingDictionary,
  deletePropale,
  validateObject,
  toasterError,
  toasterSuccess,
}
